var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{ref:"barrageWrapper",staticClass:"barrage-wrapper",style:({ height: _vm.percent + '%' })},[_c('div',{staticClass:"barrage-main",class:_vm.className},[_c('div',{ref:"barrageMainDm",staticClass:"barrage-main-dm",class:{
        'ani-pause': _vm.isPause || _vm.isClose,
        'ani-running': !_vm.isPause && !_vm.isClose,
        'ani-hide': _vm.isClose,
      }})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24710787","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Barrage/Barrage.vue
// module id = null
// module chunks = 